import { Btn } from "../../../../../AbstractElements";
import { primary } from "../../../../../utils/Constant";

export interface TabelViewBtnProps {
  onClick: (value: boolean) => void;
  label: string;
}

const ViewBtn = ({ onClick,label }: TabelViewBtnProps) => {
  return (
    <Btn className="btn-sm btn-pill" color={primary} onClick={onClick}>
      {label}
    </Btn>
  );
};

export default ViewBtn;
